/* oxlint-disable react/only-export-components -- context module exports hooks + provider */
import { createContext, use, useState, type ReactNode } from "react";

type EntryForm = {
  email: string;
  setEmail: (email: string) => void;
  challengeResponse: string;
  setChallengeResponse: (challengeResponse: string) => void;
};

const EntryFormContext = createContext<EntryForm | null>(null);

/** Holds the email and org-challenge answer across login, register, and forgotten-password. */
export const EntryFormProvider = ({
  children,
  initialEmail = "",
  initialChallengeResponse = "",
}: {
  children: ReactNode;
  initialEmail?: string;
  initialChallengeResponse?: string;
}) => {
  const [email, setEmail] = useState(initialEmail);
  const [challengeResponse, setChallengeResponse] = useState(
    initialChallengeResponse,
  );
  return (
    <EntryFormContext
      value={{ email, setEmail, challengeResponse, setChallengeResponse }}
    >
      {children}
    </EntryFormContext>
  );
};

/** Uses the entry-flow form when present; otherwise keeps the fields local (embedded login, tests). */
export const useEntryForm = (): EntryForm => {
  const ctx = use(EntryFormContext);
  const [email, setEmail] = useState("");
  const [challengeResponse, setChallengeResponse] = useState("");
  return ctx ?? { email, setEmail, challengeResponse, setChallengeResponse };
};
